import { Validator } from 'jsonschema';
import _ from 'lodash';
import { Auth } from '../../config/configuration/react';
import ApiService from '../api/ApiService';

const errors = {
  401: 'api_error_unauthorized',
  404: 'api_error_route_not_found',
  400: 'api_error_registration_unkown',
  405: 'api_error_registration_unkown',
  500: 'api_error_internal_error',
};

const validator = new Validator();

const expectedVehicleDatas = {
  id: 'vehicleDatas',
  type: 'object',
  properties: {
    vin: { type: 'string' },
    registration: { type: 'string' },
    dateOfRelease: { type: 'string', pattern: '^[0-9]{4}-[0-9]{2}-[0-9]{2}.*' },
    // dateRelease: { type: "string", pattern: "^[0-9]{4}-[0-9]{2}-[0-9]{2}.*" },
    dateGrayCard: { type: 'string', pattern: '^[0-9]{4}-[0-9]{2}-[0-9]{2}.*' },
    makeId: { type: 'number' },
    makeName: { type: 'string' },
    modelId: { type: 'number' },
    modelName: { type: 'string' },
    bodyId: { type: 'number' },
    bodyName: { type: 'string' },
    fuelId: { type: 'number' },
    fuelName: { type: 'string' },
    gearboxId: { type: 'number' },
    gearboxName: { type: 'string' },
    doors: { type: 'number' },
    seats: { type: 'number' },
    engine: { type: 'number' },
    fiscal: { type: 'number' },
    kw: { type: 'number' },
    liter: { type: 'number' },
  },
  required: [
    'registration',
    'dateOfRelease',
    'dateGrayCard',
    'makeId',
    'makeName',
    'modelId',
    'modelName',
    'bodyId',
    'bodyName',
    'fuelId',
    'fuelName',
    'gearboxId',
    'gearboxName',
    'doors',
    'seats',
    'engine',
    'kw',
    'liter',
  ],
};

// Get AAA
export default async function getAaa(registration, language, mileage) {
  if (!registration) throw new Error(errors[400]);
  const _registration = registration.replace(/[^a-zA-Z^0-9]/g, '');
  const country = Auth.country();
  let response = null;
  if (country === 'NL') {
    response = await ApiService(
      'getVehiculeByRegAutotelex',
      {
        registration: _registration,
      },
      {
        mileage,
      },
    );
    localStorage.setItem('autotelex', JSON.stringify(response.data));
  } else {
    const queryData = {
      refresh: true,
      origin: 'autobizCarcheck',
    };
    response = await ApiService(
      'getVehiculeByReg',
      {
        registration: _registration,
        country,
        language,
      },
      queryData,
    );
  }

  const vehicle = { ...response.data };

  // because the api changed, we map the new format to the previous one
  const dateOfRelease = _.get(vehicle, 'dateRelease', null);
  if (dateOfRelease) vehicle.dateOfRelease = dateOfRelease;
  const gearId = _.get(vehicle, 'gearboxId', null);
  if (gearId) vehicle.gearId = gearId;
  const gearName = _.get(vehicle, 'gearboxName', null);
  if (gearName) vehicle.gearName = gearName;
  if (country === 'NL') {
    const carType = _.get(vehicle, 'vehicleType', null);
    if (carType) vehicle.vehicleType = { name: carType };
    const versions = _.get(vehicle, 'versions', null);
    if (versions.length > 0) {
      vehicle.versionId = versions.find((v) => v.preferred === true)?.id;
      vehicle.versionName = versions.find((v) => v.preferred === true)?.name;
    }
  }

  const validation = validator.validate(vehicle, expectedVehicleDatas);

  return [vehicle, validation.errors];
}
